<template>
  <div v-if="currentPoste">
    <BreadCrumd
      :title="'Postes de charge'"
      :description="'Aperçu d\'un poste de charge'"
    />

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_poste_charge' }).catch(() => {})
          "
        >
          Liste des postes de charge
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_poste_charge-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle offre
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'gpao_poste_charge-edit',
                params: { id: currentPoste.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Poste de charge</span>
                  </td>
                  <td>
                    {{ currentPoste.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Coût horaire</span>
                  </td>
                  <td>
                    {{ currentPoste.cout_horaire | currency }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    <span v-if="currentPoste.created_by">
                      {{
                        currentPoste.created_by.prenom
                          ? currentPoste.created_by.prenom +
                            ' ' +
                            currentPoste.created_by.nom
                          : currentPoste.created_by.nom
                      }}
                    </span>
                    <span v-else>###</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Entrepôt</span>
                  </td>
                  <td>
                    {{ currentPoste.entrepot.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="currentPoste.statut"
                      class="p-2"
                    >
                      Actif
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Inactif
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-n2">
        <div class="col-md-12">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-users mr-0"></i> Composition de l'équipe du
                  poste de charge
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="card table table-sm">
                  <thead>
                    <tr class="d-flex">
                      <th class="col-3">Nom</th>
                      <th class="col-3">Prénom</th>
                      <th class="col-2">Matricule</th>
                      <th class="col-2">Email</th>
                      <th class="col-2">Téléphone</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in currentPoste.item_lists"
                      :key="index"
                      class="d-flex"
                    >
                      <td class="col-3" style="vertical-align: middle">
                        {{ item.nom }}
                      </td>
                      <td class="col-3" style="vertical-align: middle">
                        {{ item.prenom ? item.prenom : '###' }}
                      </td>
                      <td class="col-2" style="vertical-align: middle">
                        {{ item.matricule ? item.matricule : '###' }}
                      </td>
                      <td class="col-2" style="vertical-align: middle">
                        {{ item.email ? item.email : '###' }}
                      </td>
                      <td class="col-2" style="vertical-align: middle">
                        {{ item.telephone ? item.telephone : '###' }}
                      </td>
                    </tr>
                    <tr
                      v-if="currentPoste.item_lists.length === 0"
                      class="d-flex"
                    >
                      <td class="text-center col-12">Aucune donnée</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/poste-charge';
export default {
  data() {
    return {
      currentPoste: null,
      title: 'Gestion des postes de charge - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.POSTE_CHARGE + '/' + this.id)
        .then((resp) => {
          this.currentPoste = resp.data.poste_charge;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
